import { managerProfileReducer } from "./managerProfile.reducer";
import { managerPerformanceReducer } from "./managerPerformance.reducer";

// eslint-disable-next-line
export default {
  managerProfileReducer,
  managerPerformanceReducer,
};
